import { render, staticRenderFns } from "./luckyDrawDetail.vue?vue&type=template&id=71e12efe&scoped=true&"
import script from "./luckyDrawDetail.vue?vue&type=script&lang=js&"
export * from "./luckyDrawDetail.vue?vue&type=script&lang=js&"
import style0 from "./luckyDrawDetail.vue?vue&type=style&index=0&id=71e12efe&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e12efe",
  null
  
)

export default component.exports